interface ElementalListContextType {
  listId?: string | number
  parentListId?: string | number
  onList: boolean
  isOwner: ComputedRef<boolean>
  isFolder: boolean

}

export const ElementalListContext = Symbol('ElementalListContext') as InjectionKey<ElementalListContextType>

export const useElementalListContext = (): ElementalListContextType => {
  const context = inject(ElementalListContext, {
    onList: false,
    isOwner: computed(() => false),
    isFolder: false,
  })
  return context
}
